import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { CAMPAIGN_NAMES } from 'constants/personalizations';
import SignupModalContainer from 'containers/SignupModalContainer';
import * as actions from 'state/actions';
import { SIGNUP_MODAL_COOKIES } from 'state/constants';
import Settings from 'utils/Settings';

const SignupModalController = class {
  static mountSignupModalContainer = store => {
    ReactDOM.render(
      <Provider store={store}>
        <SignupModalContainer />
      </Provider>,
      document.getElementById('signup-modal-container')
    );
  };

  static fetchDyCampaigns = store => {
    store.dispatch(
      actions.fetchPersonalizations({
        names: [CAMPAIGN_NAMES.INCENTIVIZED_SIGNUP_MODAL],
      })
    );
  };

  static init = async store => {
    const hasCookie = Cookies.get(SIGNUP_MODAL_COOKIES.SIGNUP_MODAL);

    if (hasCookie) return;
    // If utm_medium === email, do not show the signup modal
    const currentURL = new URL(window.location.href);
    const lowercaseSearchParams = currentURL.search.toLowerCase();
    const searchParams = new URLSearchParams(lowercaseSearchParams);
    const isFromEmailCampaign = searchParams.get('utm_medium') === 'email';
    const isInfluencerTraffic = searchParams.get('utm_source') === 'influencer';

    if (isEmpty(Settings.signupModal) || isFromEmailCampaign || isInfluencerTraffic) return;

    SignupModalController.fetchDyCampaigns(store);
    SignupModalController.mountSignupModalContainer(store);
  };
};

export default SignupModalController;
